import * as faker from 'faker';
import { ShipmentFactory } from '@library/common/models/mock';
import { Template } from './template';

export class MockTemplate extends Template {
   constructor() {
      super();

      this.id = faker.datatype.number( 100 );
      this.name = faker.company.catchPhraseAdjective() + ' ' + faker.company.catchPhraseNoun();
      this.owner_name = faker.name.findName();
      this.last_updated = faker.date.recent().toISOString().slice( 0, 10 );
      this.shared = faker.datatype.boolean();
      this.owned = true;

      this.data = ShipmentFactory.mock();
   }
}
